import { useState } from 'react';
import { useRegion } from '../context/RegionContext';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

/**
 * useCheckout()
 *
 * Devuelve { checkout, loading, error }
 *
 * checkout(items) → envía región via header x-region → redirige a Stripe Checkout
 *
 * items: [{ id, quantity }]
 * La región se toma automáticamente del URL (RegionContext).
 */
export function useCheckout() {
  const { region } = useRegion();
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  async function checkout(items, shippingInfo = {}) {
    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${API}/api/checkout/create-session`, {
        method:  'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-region':     region,
        },
        body: JSON.stringify({ items, ...shippingInfo }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || 'Error al iniciar el pago.');

      window.location.href = data.url;
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }

  return { checkout, loading, error };
}
